__turbopack_context__.v({
  "chaos": "WhyMeidly-module__HKkLRq__chaos",
  "container": "WhyMeidly-module__HKkLRq__container",
  "fragment": "WhyMeidly-module__HKkLRq__fragment",
  "head": "WhyMeidly-module__HKkLRq__head",
  "resolution": "WhyMeidly-module__HKkLRq__resolution",
  "resolutionArrow": "WhyMeidly-module__HKkLRq__resolutionArrow",
  "resolutionEmphasis": "WhyMeidly-module__HKkLRq__resolutionEmphasis",
  "resolutionSplit": "WhyMeidly-module__HKkLRq__resolutionSplit",
  "resolutionText": "WhyMeidly-module__HKkLRq__resolutionText",
});
